module.exports = __webpack_public_path__ + "static/media/4.Highlighted Spread.29434aab.jpg";